import { Box, LoadingOverlay } from "@mantine/core";
import { MouseEventHandler, useCallback, useMemo, useRef } from "react";

import { DropdownOptions } from "@components";
import { usePrintable } from "@hooks";
import { useTranslation } from "react-i18next";

interface PrintableDropdownOptionsProps {
  filename?: string;
  showDownloadSettingsLink?: boolean;
  options?: {
    children: React.ReactNode | string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
  }[];
}
export default function PrintableDropdownOptions({
  filename,
  showDownloadSettingsLink,
  options,
}: PrintableDropdownOptionsProps) {
  const ref = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();
  const { generate, loading } = usePrintable();

  const handlePrintSection = useCallback(
    (type) => {
      const ref_ = ref.current;

      if (!ref_) {
        return;
      }

      const section = ref_.closest(".printable-section") as HTMLElement;
      generate(type, { section, filename, showDownloadSettingsLink });
    },
    [filename, showDownloadSettingsLink, generate],
  );

  const defaultOptions = useMemo(
    () => [
      { children: t("ResultList.print"), onClick: () => handlePrintSection("print") },
      { children: t("ResultList.pdf"), onClick: () => handlePrintSection("download") },
    ],
    [t, handlePrintSection],
  );

  return (
    <Box ref={ref} className="no-print">
      <LoadingOverlay visible={loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
      <DropdownOptions options={[...defaultOptions, ...(options ?? [])]} />
    </Box>
  );
}
